import React from "react";
import { useStaticQuery, graphql, navigate } from "gatsby";
import Img from "gatsby-image";
// import MiscSocialSmall from "./../../components/icons/MiscSocialSmall";
import ArtsFoundationHeroLanding from "./../../components/ArtsFoundationHeroLanding";
import Layout from "./../../components/Layout";
import FoundationRequestInformationForm from "./../FoundationRequestInformationForm";
import {
    AlserkalAdvisoryWrapperDiv,
    AlserkalAdvisoryWrapperInnerDiv,
    AlserkalAdvisoryWrapperWhiteDiv,
} from "./elements";

const AlserkalAdvisoryWrapper = ({
    children,
    title,
    selected,
    selection,
    selectClass

}) => {
    const basicQuery = useStaticQuery(graphql`
    {
    craftAlserkalAdvisoryAlserkalAdvisoryEntry {
        
        seoTitle
        seoDescription
        advisoryHeaderImages {
            ... on Craft_advisoryHeaderImages_headerImages_BlockType {
              aboutBanner {
                ... on Craft_communityAssets_Asset {
                  mobile: localFile {
                    publicURL
                    childImageSharp {
                      fixed(width: 420, height: 210, fit: COVER) {
                        src
                        ...GatsbyImageSharpFixed
                      }
                    }
                  }
                  card: localFile {
                    publicURL
                    childImageSharp {
                      fixed(width: 690, height: 420, fit: COVER) {
                        src
                        ...GatsbyImageSharpFixed
                      }
                    }
                  }
                }
                ... on Craft_editorialAssets_Asset {
                  mobile: localFile {
                    publicURL
                    childImageSharp {
                      fixed(width: 420, height: 210, fit: COVER) {
                        src
                        ...GatsbyImageSharpFixed
                      }
                    }
                  }
                  card: localFile {
                    publicURL
                    childImageSharp {
                      fixed(width: 690, height: 420, fit: COVER) {
                        src
                        ...GatsbyImageSharpFixed
                      }
                    }
                  }
                }
              }
              ourWorkBanner {
                ... on Craft_communityAssets_Asset {
                  mobile: localFile {
                    publicURL
                    childImageSharp {
                      fixed(width: 420, height: 210, fit: COVER) {
                        src
                        ...GatsbyImageSharpFixed
                      }
                    }
                  }
                  card: localFile {
                    publicURL
                    childImageSharp {
                      fixed(width: 690, height: 420, fit: COVER) {
                        src
                        ...GatsbyImageSharpFixed
                      }
                    }
                  }
                }
                ... on Craft_editorialAssets_Asset {
                  mobile: localFile {
                    publicURL
                    childImageSharp {
                      fixed(width: 420, height: 210, fit: COVER) {
                        src
                        ...GatsbyImageSharpFixed
                      }
                    }
                  }
                  card: localFile {
                    publicURL
                    childImageSharp {
                      fixed(width: 690, height: 420, fit: COVER) {
                        src
                        ...GatsbyImageSharpFixed
                      }
                    }
                  }
                }
              }
              upomingProgrammesBanner {
                ... on Craft_communityAssets_Asset {
                  mobile: localFile {
                    publicURL
                    childImageSharp {
                      fixed(width: 420, height: 210, fit: COVER) {
                        src
                        ...GatsbyImageSharpFixed
                      }
                    }
                  }
                  card: localFile {
                    publicURL
                    childImageSharp {
                      fixed(width: 690, height: 420, fit: COVER) {
                        src
                        ...GatsbyImageSharpFixed
                      }
                    }
                  }
                }
                ... on Craft_editorialAssets_Asset {
                  mobile: localFile {
                    publicURL
                    childImageSharp {
                      fixed(width: 420, height: 210, fit: COVER) {
                        src
                        ...GatsbyImageSharpFixed
                      }
                    }
                  }
                  card: localFile {
                    publicURL
                    childImageSharp {
                      fixed(width: 690, height: 420, fit: COVER) {
                        src
                        ...GatsbyImageSharpFixed
                      }
                    }
                  }
                }
              }
              
            }
          }
      }
    }
  `).craftAlserkalAdvisoryAlserkalAdvisoryEntry;

    const alservalAdvisoryImagesQuery = basicQuery.advisoryHeaderImages[0];
    var alservalAdvisorySeoTitle = basicQuery.seoTitle ? basicQuery.seoTitle : null;
    var alservalAdvisorySeoDescription = basicQuery.seoDescription ? basicQuery.seoDescription : null;

    const images = [
        {
            image: (
                <React.Fragment>
                    <Img
                        className="desktop"
                        fixed={
                            alservalAdvisoryImagesQuery.aboutBanner[0].card.childImageSharp.fixed
                        }
                    />
                    <Img
                        className="mobile"
                        fixed={
                            alservalAdvisoryImagesQuery.aboutBanner[0].mobile.childImageSharp
                                .fixed
                        }
                    />
                </React.Fragment> 
            ),
            link: "/alserkal-advisory/",
            title: "Who we are",
            slug:'alserkal-advisory/'
        },
        {
            image: (
                <React.Fragment>
                    <Img
                        className="desktop"
                        fixed={
                            alservalAdvisoryImagesQuery.upomingProgrammesBanner[0].card.childImageSharp.fixed
                        }
                    />
                    <Img
                        className="mobile"
                        fixed={
                            alservalAdvisoryImagesQuery.upomingProgrammesBanner[0].mobile.childImageSharp
                                .fixed
                        }
                    />
                </React.Fragment>
            ),
            link: "/alserkal-advisory/our-work",
            title: "Our work",
            slug:"our-work"
        }
    ];

    // console.log(basicQuery);

    return (
        <Layout
            fullWidth
            backgroundColor={"var(--white)"}
            title={alservalAdvisorySeoTitle}
            SEODescription={alservalAdvisorySeoDescription} >
            <AlserkalAdvisoryWrapperDiv className="ak-background">
                <AlserkalAdvisoryWrapperInnerDiv>
                    {/*<MiscSocialSmall color={"var(--black)"} />*/}
                    <ArtsFoundationHeroLanding
                        title={title}
                        selected={selected}
                        selection={selection}
                        menuItems={images}
                        returnLink={(e) => {
                            navigate(e);
                        }}
                        selectClass={selectClass}
                        backgroundColor={"var(--white)"}
                    />
                    {children}
                </AlserkalAdvisoryWrapperInnerDiv>
                
                
            </AlserkalAdvisoryWrapperDiv>
        </Layout>
    );
};

export default AlserkalAdvisoryWrapper;
